





























































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Game } from '@/class/game'
import Header from '../Header.vue'
import SectionRegulation from './SectionRegulation.vue'
import SectionPlayerList from './SectionPlayerList.vue'
import SectionGameLog from './SectionGameLog.vue'
import GameStateModal from './GameStateModal.vue'
import Cutin from '@/components/Utils/Cutin.vue'
import { GamePlayer } from '@/class/gamePlayer'

@Component({
  components: {
    Header,
    SectionRegulation,
    SectionPlayerList,
    SectionGameLog,
    GameStateModal,
    Cutin,
  }
})

export default class Play extends Vue {
  @Prop() game!: Game
  @Prop() playerSelf?: GamePlayer
  @Prop() isGallary!: boolean
  @Prop() userInterfaceType!: 'A' | 'B'

  showsCutin = false;
  
  display: 'playerList' | 'regulation' | 'gameLog' = 'playerList'

  created () {
    this.$watch('isAllPlayerTurnEnd', (now) => {
      if (now) {
        this.setNextState()
      }
    })
  }

  get isNight() {
    return this.game.isNight || this.game.isFirstNight
  }

  get showsPlayerList() {
    return this.display === 'playerList'
  }

  get showsRegulation() {
    return this.display === 'regulation'
  }

  get showsGameLog() {
    return this.display === 'gameLog'
  }

  get isAllPlayerTurnEnd (): boolean {
    return this.game.isAllPlayerTurnEnd
  }

  get isGameMaster () {
    return this.game.masterId === this.playerSelf?.id && !this.isGallary
  }

  get gameViewer () {
    return this.$refs.gameViewer as Element
  }

  setNextState () {
    if (!this.isGameMaster || this.game.isGameover) return

    this.game.setNextState()
  }

  showCutin () {
    this.showsCutin = true;
  }

  hideCutin () {
    this.showsCutin = false;
  }

  onTimeover () {
    this.hideCutin()

    if (!this.playerSelf) return

    this.playerSelf.updateTurnEnd(true)
  }

  onRemind () {
    this.showCutin();
  }

  get cutinMessage () {
    if ((this.game.isDay && this.game.dayVote) || this.game.isVoteStart) {
      return "投票締め切りまであと少し！"
    }

    if (this.game.isNight || this.game.isFirstNight) {
      return "もうすぐ夜が明ける！"
    }

    return ""
  }
 
  showPlayerList() {
    this.display = 'playerList'
    this.gameViewer.scroll(0, 0)
  }

  showRegulation() {
    this.display = 'regulation'
    this.gameViewer.scroll(0, 0)
  }

  async showGameLog() {
    this.display = 'gameLog'
    await this.$nextTick()
    this.gameViewer.scroll(0, this.gameViewer.scrollHeight)
  }
}
